import { render, staticRenderFns } from "./TabDuplicate.vue?vue&type=template&id=fa022daa&scoped=true"
import script from "./TabDuplicate.vue?vue&type=script&lang=js"
export * from "./TabDuplicate.vue?vue&type=script&lang=js"
import style0 from "./TabDuplicate.vue?vue&type=style&index=0&id=fa022daa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa022daa",
  null
  
)

export default component.exports